import { t } from "i18next";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import AccessOpenings from "../../components/AccessOpenings/AccessOpenings";
import ButtonBlackReturn from "../../components/Buttons/ButtonBlackReturn";
import { CustomAlert } from "../../components/CustomAlert/CustomAlert";
import AccessOpeningContext from "../../context/AccessOpeningContext/AccessOpeningContext";
import {
  getTenantInfoByKey,
  getUserOpening,
  havePermission,
} from "../../helpers/helpers";
import { logout } from "../../services/login";

const SelectAccessOpening = () => {
  const { accessOpeningState, getAccessOpenings, setAccessOpening } =
    useContext(AccessOpeningContext);
  const { accessOpenigs, isFetching, error, message } = accessOpeningState;

  const navigate = useNavigate();
  const location = useLocation();
  const isChangeOpeningFlow = location.state?.hideNavbarWelcome === true;
  const canMakeAccess = havePermission(1);

  const haveAccessOpenings = getTenantInfoByKey("is_access_opening");

  const haveSelectAnOpening = getUserOpening();

  const navigateToSelectBuildingsState = () => {
    const navigateState = location.state;
    const hasTrail =
      navigateState?.hideNavbarWelcome === true || navigateState?.accessSelectionFromSidebar;
    if (!hasTrail) return undefined;
    return {
      ...(navigateState?.hideNavbarWelcome === true ? { hideNavbarWelcome: true } : {}),
      ...(navigateState?.accessSelectionFromSidebar
        ? { accessSelectionFromSidebar: navigateState.accessSelectionFromSidebar }
        : {}),
    };
  };

  const handleSelectOpening = (opening) => {
    setAccessOpening(opening);
    const nextState = navigateToSelectBuildingsState();
    navigate(
      "/selectAccessBuildings",
      nextState ? { state: nextState } : {}
    );
  };

  useEffect(() => {
    if (haveSelectAnOpening) {
      const nextState = navigateToSelectBuildingsState();
      navigate(
        "/selectAccessBuildings",
        nextState ? { state: nextState } : {}
      );
      return;
    }
    if (canMakeAccess === true && haveAccessOpenings === true) {
      getAccessOpenings(false, isChangeOpeningFlow);
    } else {
      handleSelectOpening({ codigo: "", descripcion: t("NO_OPENING") });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="pe-4 ps-4 h-100">
      {isFetching ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <Spinner />
        </div>
      ) : (
        <div>
          {!isChangeOpeningFlow && (
            <ButtonBlackReturn
              onClick={logout}
              title={`${t("CHOOSE_OPENING")} ${getTenantInfoByKey(
                "opening_name"
              )}`}
            />
          )}

          {isChangeOpeningFlow && (
            <h5 className="ps-2 pb-2 m-0 custom-h4">
              {`${t("CHOOSE_OPENING")} ${getTenantInfoByKey("opening_name")}`}
            </h5>
          )}

          <div className={isChangeOpeningFlow ? "mt-0" : "mt-3"}>
            {error ? <CustomAlert color={"danger"} text={message} /> : null}
            <AccessOpenings
              accessOpenigs={accessOpenigs}
              selectOpening={handleSelectOpening}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectAccessOpening;
